import { TFasterPayoutSourceFilter } from '../../../../../api/src';

export const FPS_SOURCE_OPTIONS: TFasterPayoutSourceFilter[] = [
  'any',
  'api',
  'mc',
];
